import { breakpoints, theme, ThemeDefinition } from "@shapeable/theme";
import { Banner, Color } from "@shapeable/types";
import { WARM_GREY } from "@shapeable/ui";
import { css } from "styled-components";

export const MEDIUM_BLUE = '#2496BD';
export const DARK_BLUE = '#02394B';
export const CONTENT_BACKGROUND = '#FFF';

export const GREEN = '#005D25';


export const LIGHT_GREEN = '#377F43';
export const LIGHT_BLUE = '#00B8D9';
export const BLUE = '#0673BE';
export const DARK_RED = '#990008';
export const LIGHT_BROWN = '#AD9A8A';
export const GOLD = '#FFA200';

export const BRAND_1 = GREEN;
export const BRAND_2 = LIGHT_GREEN;
export const BRAND_3 = LIGHT_BLUE;
export const BRAND_4 = BLUE;
export const BRAND_5 = DARK_RED;
export const BRAND_6 = LIGHT_BROWN;
export const BRAND_7 = GOLD;

export const BRAND_COLORS = [BRAND_1, BRAND_2, BRAND_3, BRAND_4, BRAND_5, BRAND_6, BRAND_7];

export const LIGHT_BIEGE = '#F7F5F3';
export const VERY_LIGHT_BROWN = '#D5CDC4';
export const MEDIUM_BROWN = '#796c61';
export const DARK_BROWN = '#685c53';

export const BANNER_EVENT: Banner = {
  id: 'banner-event',
  name: 'Banner Event',
  slug: 'banner-event',
  image: {
    id: 'recYRsg6ML0rqtefA_image',
    url: 'https://res.cloudinary.com/shapeable/image/upload/v1668989821/villars-institute/banner/sub-page-banner-event_image__event-banner.jpg',
    width: 1920,
    height: 576,
  },
};

export const COLOR_LIGHT_BROWN: Color = {
  id: 'light-brown',
  slug: 'light-brown',
  value: LIGHT_BROWN,
};

export const themeOverrides: ThemeDefinition = {
  font: {
    family: {
      serif: "'Cormorant Garamond', georgia, serif",
      sans: 'Jost, sans-serif',
      heading: 'Jost, sans-serif',
      copy: 'Jost, sans-serif',
    }
  },
  light: {
    color: {
      primary: GREEN,
      secondary: LIGHT_GREEN,
      heading: GREEN,
      buttonHover: LIGHT_GREEN,
    },
  },
  dark: {
    color: {
      bright: '#050d07',
      primary: VERY_LIGHT_BROWN,
      secondary: VERY_LIGHT_BROWN,
    }
  }
};


/* 
--------------------

  Layout Styles
  
  NB: This is the appropriate place to override styling for this specific site, based on BEM-style class name targets 
  
--------------------
*/

export const LayoutStyles = breakpoints({
  base: css`

    .shp--organisation-powered-by {
      img {
        mix-blend-mode: color-burn;
        filter: grayscale(1);
      }

      &:hover {
        filter: none;
      }
    }

    .shp--slice-intro .shp--markdown-content {
      font-size: 1em;
      text-align: left;
      line-height: 1.35em;
      font-weight: 300;
    }

    .page-home .shp--page-layout-standard__banner-titles div div {
      flex-direction: column;
      gap: 0.25em;

      h1 {
        align-self: flex-start;
      }
    }

    .shp--site-menu-bar__title {
      color: ${theme.COLOR('light')}
    }

    .shp--slice-key-message {
      text-align: left;

      .shp--content {
        line-height: 1.10em;
        font-family: ${theme.FONT('sans')};
        font-weight: 400;
      }
      
      .shp--slice-key-message__links {
        align-items: flex-start;
      }
    }

    .shp--slice-layout-content-with-image {
      .shp--content-node {
        color: ${theme.COLOR('inherit')};
      }
      li::before {
        color: ${theme.COLOR('inherit')};
      }
    }

    #customers .shp--button {
      color: ${theme.COLOR('light')};
      ${theme.FILL('light')};
      border: 2px dotted ${theme.COLOR('light')};
      &:hover {
        color: ${theme.COLOR('#FCB10F')};
        ${theme.FILL('#FCB10F')};
        border: 2px dotted ${theme.COLOR('#FCB10F')};
      }
    }

  `,
  tablet: css`
    .shp--slice-intro .shp--markdown-content {
      font-size: 1.5em;
    }

  `,
  desktop: css`
    .shp--site-menu-bar {
      opacity: 0.97;
    }
  `,
});